module.exports = __webpack_public_path__ + "img/video-control--next.1833fc95.svg";